import { CrosstabOptions } from 'components/financials/crosstab/CrosstabTypes';

export const getDefaultCrosstabOptions = (): CrosstabOptions => ({
    showTotalsAtEndOfGroup: false,
    showInOutlineForm: false,
    hideColumnSubtotals: false,
});
